import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple">INTRODUCE</span> MYSELF
            </h1>

            <p className="home-about-body">
              Ever since I started programming, it’s been a journey of constant learning and curiosity.
              <br />
              <br />
             I'm confident working with core technologies such as 
              <i>
                <b className="purple"> Java, Spring Boot, and MySQL .</b>
              </i>
              
              <br />
              <br />
             I have a strong interest in crafting modern
              <i>
                <b className="purple">Web Technologies and Products</b>
              </i>
              , and exploring areas related to&nbsp;
              <i>
                <b className="purple">Cloud Computing</b>
              </i>
              .
              <br />
              <br />
              I actively channel my passion into building products with
              <i>
                <b className="purple">Node.js</b>
              </i>
              &nbsp;and modern JavaScript libraries and frameworks like&nbsp;
              <i>
                <b className="purple">React.js</b> and <b className="purple">Next.js</b>
              </i>
              .
            </p>
          </Col>

          <Col md={4} className="myAvtar">
            <Tilt>
              {/* You can place your avatar image here */}
              {/* <img src={myImg} className="img-fluid" alt="avatar" /> */}
            </Tilt>
          </Col>
        </Row>

        <Row>
          <Col md={12} className="home-about-social">
            <h1>Reach out to me on</h1>
            <p>
              Feel welcome <span className="purple">to get in touch.</span>
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/ashwinikumar76"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/ashwini-nayak76"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>

              <li className="social-icons">
                <a
                  href="https://www.instagram.com/ashwini_k._nayak/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
